import { Component, EventEmitter,OnInit, ViewEncapsulation,Input,Output } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { RacingService } from '../../../rest/racing.service';
import { ExcelMappingService } from 'app/modules/task/Logistics/services/excel-mapping.service';
import { Rest } from 'app/rest/rest_client';
import { Rest_logistics } from 'app/modules/task/Logistics/services/rest_client_logistics';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { Rest_task } from 'app/modules/task/administration/services/rest_client_task';

@Component({
	selector: 'app-racing-excel',
	templateUrl: './racing-excel.component.html',
	styleUrls: ['./racing-excel.component.css'],
	providers: [ExcelMappingService],
	encapsulation: ViewEncapsulation.None,
})
export class RacingExcelComponent implements OnInit {
	@Input() eventId: number;
    @Output() closeDialog = new EventEmitter<any>();
	isDialogVisible: boolean = false;
	isEditingDisabled: boolean = false;
	isSaveGranted: boolean = false;
	errorMessages: string[] = [];
	severeError: boolean = false;
	formTitle: string = 'Import POIS from Excel';
	buttonview: string = 'Preview';
	buttongenerate:string ='Generate';

	importExcelSubscription: Subscription;

	/* pasos */
	// entityFieldsLoaded: boolean = false;
	// excelLoaded: boolean = false;
	// excelLoading: boolean = false;
	loadedEntity: boolean = false;
	loadedExcel: boolean = false;
	previewSpinner: boolean = false;
	generateSpinner: boolean = false;
	start: boolean = false;
	previewReady: boolean = false;
	generateReady: boolean = false;

	/* file */
	file: string = '';

	/* mapping */
	mapping = new Map<String, String>();
	defaultMapping: boolean = false;
	excelMapping: Rest_logistics.ExcelMapping;
	// --> this.mapping.set("sss","sss");
	// --> this.mapping.get("sss");

	/* orders */
	dinamicList: any[] = [];
	tableColspan: string = '0';
	result: boolean = false;

	/* Fields */
	fieldList: string[] = [];
	duplicateFieldAlertList: string[] = [];
	selectedField: string[] = [];
	tableHeaders: string[] = [];
	componentClass: string[] = [];
	sampleList: string[] = [];
	cols: { header: string, field: string, subfield: string, type: string }[] = [];
	newgenerate:boolean = false;
	/* excel */
	documentFile: any;
	columnList: string[] = [];

	poisgenerate: Rest.POIRacing[] = [];

	constructor(
		private datePipe: DatePipe,
		private excelMappingService: ExcelMappingService,
		protected authenticationService: AuthenticationService,
		protected notificationsService: NotificationsService,
		protected translate: TranslateService,
		protected racingService: RacingService
	) {
	}

	ngOnInit(): void {
		//console.log('[ORDERS-FROM-EXCEL] ngOnInit ***');
		this.formTitle= this.translate.instant('events.pois.importPOIs');
		this.buttonview= this.translate.instant('logistics.orders.importExcel.preview');
		this.buttongenerate= this.translate.instant('logistics.orders.importExcel.generate');
		this.importExcelSubscription = this.racingService.startImport.subscribe(() => {
			console.log('______ START IMPORT ______');
			this.showDialog();
		});
	}

	showDialog() {
		console.log('[ORDERS-FROM-EXCEL] showDialog ***');
		this.isDialogVisible = true;
		this.loadedEntity = false;
		this.loadedExcel = false;
		this.previewSpinner = false;
		this.generateSpinner = false;
		this.start = false;
		this.previewReady = false;
		this.generateReady = false;
		this.documentFile = null;
		this.cols = [];
		this.tableHeaders = [];
		this.componentClass = [];
		this.selectedField = [];
		this.result = false;
		this.fieldList = [];
		this.getDefaultMapping();
		this.getPOISFields();
	}

	/*****************************************/
	/*** QUERY'S                           ***/
	/*****************************************/
	public getPOISFields() {
		this.loadedEntity = false;
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.racingService
				.Poi_getFields()
				.then(
					function (response) {
						that.loadedEntity = true;
						that.fieldList=[];
						that.fieldList = response;

					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					}
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}


	public getExcelColumns(document: any) {
		// console.log('[ORDERS-FROM-EXCEL] getExcelColumns ***');
		this.loadedExcel = false;
		this.cols = [];
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.racingService
				.Poi_getExcelFields(document,"POIS")
				.then(
					function (response) {
						that.columnList = response;
						that.loadedExcel = true;
						that.previewReady = true;
						if (that.defaultMapping)
							that.notificationsService.add(
								Severity.info,
								'INFO',
								that.translate.instant('logistics.orders.importExcel.defaultMappingLoaded')
							);
						that.isSaveGranted = that.defaultMapping;
						that.getExcelSamples(that.documentFile);
						if (that.mapping) that.setTableHeaders();
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						that.loadedExcel = true;
						resolve();
					}
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public getExcelSamples(document: any) {
		// console.log('[ORDERS-FROM-EXCEL] getExcelSamples ***');
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.racingService
				.Poi_getExcelSamples(document,"POIS")
				.then(
					function (response) {
						that.sampleList = response;
						// console.log('that.sampleList...');
						// console.log(that.sampleList);
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					}
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}



	public getDefaultMapping() {
		// console.log('[ORDERS-FROM-EXCEL] getDefaultMapping (' + sourceType + ') ***');
		this.defaultMapping = false;
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.excelMappingService
				.find('POIS')
				.then(
					function (response) {
						if (response) {
							that.excelMapping = response[0];
							that.deserializeMapping(that.excelMapping.mappingJson);
							that.defaultMapping = true;
						}
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					}
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public setDefaultMapping(isNew: boolean) {
		let excelMapping = {
			id: isNew ? 0 : this.excelMapping.id,
			client: { id: this.authenticationService.user.client.id },
			name: 'POIS, client ' + this.authenticationService.user.client.id,
			objectClass: 'POIS',
			mappingJson: this.serializeMapping(),
			enabled: true,
		};

		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.excelMappingService
				.create(excelMapping)
				.then(
					function (response) {
						that.excelMapping = response;
					},
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					}
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	/*****************************************/
	/*** EVENTS                            ***/
	/*****************************************/
	public onChangeField(event: any, index: number) {
		this.tableHeaders = [];
		this.componentClass = [];
		this.defaultMapping = false; //qualsevol canvi desmarca el mapping per defecte

		this.selectedField.forEach((x) => {
			/* establecer cabeceras tabla de Orders */
			if (x) this.tableHeaders.push(x);
		});

		/* verificar que no se este usando campos duplicados */
		this.selectedField.forEach((n) => {
			this.detectDuplicate(this.selectedField, this.selectedField.indexOf(n));
		});

		/* habilitar boton de generar */
		this.isSaveGranted = false;
		this.selectedField.forEach((x) => {
			if (x) this.isSaveGranted = true;
		});
	}

	public onRemoveField(index: number) {
		// console.log('[ORDERS-FROM-EXCEL] onRemoveField ***');
		this.tableHeaders = [];
		this.selectedField[index] = null;
		this.defaultMapping = false; //qualsevol canvi desmarca el mapping per defecte

		this.setTableHeaders();
		this.componentClass = [];
		this.selectedField.forEach((n) => {
			this.detectDuplicate(this.selectedField, this.selectedField.indexOf(n));
		});
		/* habilitar boton de generar */
		this.isSaveGranted = false;
		this.selectedField.forEach((x) => {
			if (x) this.isSaveGranted = true;
		});
		// console.log(this.tableHeaders);
	}

	public changeDocument(event) {
		// console.log('[ORDERS-FROM-EXCEL] changeDocument ***');
		// console.log(event);
		this.start = true;
		this.previewSpinner = false;
		this.documentFile = event.target.files[0];
		this.getExcelColumns(this.documentFile);

	}

	// public onChangeType(event) {
	// 	// console.log('[ORDERS-FROM-EXCEL] onChangeType ***');
	// 	// console.log(event);
	// 	this.start = true;
	// 	this.fieldList = [];
	// 	this.getDefaultMapping();
	// 	this.getPOISFields();
			
	// }

	public detectDuplicate(array: string[], index: number) {
		let indexes: number[] = [];
		//console.log(array);
		for (let i = 0; i < array.length; i++) {
			if (array[i] && array[i] === array[index]) indexes.push(i);
		}
		if (indexes.length > 1) {
			indexes.forEach((y) => {
				// console.log("index: " + index + ", y: " + y + " --> " + array[index] + " === " + array[y]);
				if (array[y] === array[index] && y < array.length) this.componentClass[y] = 'ng-invalid';
			});
		}
	}

	public process() {
		// console.log("[ORDERS-FROM-EXCEL] process ***");
		this.generateSpinner = true;
		this.generatePois(this.documentFile, this.serializeMapping(), 0, false,this.eventId);
			
	}

	public preview() {
		// console.log("[ORDERS-FROM-EXCEL] preview ***");
		this.result = false;
		this.previewSpinner = true;
		if (this.selectedField.length > 0) this.generatePois(this.documentFile, this.serializeMapping(), 10, true,this.eventId);
	}

	public generatePois(document: any, mapping: string, limit: number, simulation: boolean, eventId:number) {
		this.poisgenerate = [];
		// console.log('[ORDERS-FROM-EXCEL] generateContents ***');
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.racingService
				.Poi_generatePois(
					document,
					mapping,
					limit,
					simulation,
					eventId
				)
				.then(
					function (response) {
						that.dinamicList = response;
						if (simulation) {
							that.previewSpinner = false;
							that.generateReady = true;
						}else{
							that.generateSpinner = false;
						}
						if (simulation)
							{ that.getPreview();

							that.newgenerate = false;
							}else 
						{that.result = true;
						that.poisgenerate = response;
						that.newgenerate = true;
						that.closeDialog.emit(that.poisgenerate);
						}
					},
					/* failure */
					function (error) {
						that.result = false;
						console.log('The request failed: ' + error);
						that.notificationsService.add(
							Severity.error,
							'ERROR',
							that.translate.instant('logistics.orders.errorcreate')
						);
						resolve();
					}
				)
				.catch(function (reason) {
					that.result = false;
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}


	public onChangeDefaultMapping(event) {
		if (event.checked) this.setDefaultMapping(this.excelMapping ? false : true);
	}

	public serializeMapping(): string {
		let mapping: any = {};
		for (let i = 0; i < this.columnList.length; i++) {
			if (this.selectedField[i]) mapping[this.columnList[i].toLowerCase()] = this.selectedField[i];
		}
		return JSON.stringify(mapping);
	}

	public deserializeMapping(mapping: string) {
		this.mapping = JSON.parse(mapping);
		this.selectedField = [];
		this.selectedField = Object.values(this.mapping);
	}

	public setTableHeaders() {
		this.selectedField.forEach((x) => {
			if (x) this.tableHeaders.push(x);
		});
		this.tableColspan = this.tableHeaders.length.toString();
	}

	/**** FALTA ESTO CAMBIA */
	public getPreview() {
		this.cols = [];
		this.tableHeaders.forEach( x => {
			let type: string;
			 switch(x.toLowerCase()) {
			 	case "longitude":
			 	case "latitude":
			 		type = "number";
			 		break;
			 	default:
					type = "string";
			 }
			let spl: string[] = x.split(".");
			this.cols.push({ header: (spl.length > 1 ? spl[1] : x), field: spl[0], subfield: spl[1], type: type});
		});


	}
	onVisibleChange()
	{
		// if (this.isDialogVisible==false) 
		// {
		// 	this.closeDialog.emit(this.poisgenerate);
		// }
	}
}
